import script from "./StampCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StampCard.vue?vue&type=script&setup=true&lang=js"

import "./StampCard.vue?vue&type=style&index=0&id=3b681c1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b681c1a"]])

export default __exports__